import React from 'react'
import { Form as RsForm, Row, Col, Label } from 'reactstrap'
import { Validator } from 'components/validation'
import { Select } from 'components/select'
import { DatePicker } from 'components/datePicker'
import { api as storagePlacesApi } from 'store/modules/lookups/storagePlaces'
import { api as suppliersApi } from 'store/modules/lookups/suppliers'
import { api as winesApi } from 'store/modules/lookups/wines'
import { Input } from 'components/inputs'
import { storageStatus } from 'enums/storageStatus'
import { soldByChannel } from 'enums/soldByChannel'
import { dialogTypes } from 'decorators'
import { AddItemButton } from 'components/buttons'
import { getComponentKey } from 'utils/getComponentKey'
import { WineDetails } from './wineDetails'
import { useStyles } from './form.css'
import { QuickSellButtons } from 'components/bottles/quickSellButtons'

const Form = (props) => {
  const classes = useStyles()
  const [wineKey, setWineKey] = React.useState(getComponentKey())
  const handleWineUpdate = React.useCallback(() => setWineKey(getComponentKey()), [])
  const { isInDialog, context, quickSell,  data } = props
  const { disabled, updateEntity, localize } = props
  const { entity, quickSelling } = data
  if (!entity) { return null }

  return (
    <React.Fragment>
      {!props.isInDialog && <WineDetails localize={localize} wineId={(entity.wine || {}).id} onWineUpdate={handleWineUpdate} />}
      <RsForm>
        <Row>
          <Col sm={6}>
            <Label>{localize('bottles.wine')}</Label>
            <AddItemButton dialogType={dialogTypes.wineDetail} onCreatedEntity={updateEntity('wine')}>
                <Validator name='wine' value={entity.wine} required>
                  <Select
                    key={wineKey}
                    dataSource={winesApi.get}
                    value={entity.wine}
                    onChange={updateEntity('wine')}
                    nullable
                    />
                </Validator>
              </AddItemButton>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <div><Label>{localize('bottles.dateOfOrder')}</Label></div>
            <DatePicker disabled={disabled} value={entity.dateOfOrder} onChange={updateEntity('dateOfOrder')} />
          </Col>
          <Col sm={3}>
            <Label>{localize('bottles.bottleStatus')}</Label>
            <Select value={entity.status} onChange={updateEntity('status')}
                placeholder={localize('bottles.bottleStatus')} disabled={disabled}
                enum={storageStatus} />
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <Label>{localize('bottles.supplierName')}</Label>
            <AddItemButton dialogType={dialogTypes.supplierDetail} onCreatedEntity={updateEntity('supplier')}>
              <Validator name='supplier' value={entity.supplier} required>
                <Select
                  dataSource={suppliersApi.get}
                  value={entity.supplier}
                  onChange={updateEntity('supplier')}
                  nullable
                  />
              </Validator>
            </AddItemButton>
          </Col>
          <Col sm={3}>
            <Label>{localize('bottles.dateOfArrival')}</Label>
            <Validator name='dateOfArrival' value={entity.dateOfArrival} required={entity.status === storageStatus.stored || entity.status === storageStatus.sold}
              disabled={disabled} style={{ width: 205 }}>
              <DatePicker disabled={disabled} value={entity.dateOfArrival} onChange={updateEntity('dateOfArrival')} />
            </Validator>
          </Col>
          <Col sm={3}>
            <Label>{localize('bottles.acquisitionPrice')}</Label>
            <Validator name='acquisitionPrice' value={entity.acquisitionPrice} required>
              <Input isNumeric disabled={disabled} value={entity.acquisitionPrice} onChange={updateEntity('acquisitionPrice')} />
            </Validator>
          </Col>
          <Col sm={3}>
            <Label>{localize('bottles.storagePlace')}</Label>
            <AddItemButton dialogType={dialogTypes.storagePlaceDetail} onCreatedEntity={updateEntity('storagePlace')}>
              <Validator name='storagePlace' value={entity.storagePlace} required={entity.status === storageStatus.stored}>
                <Select
                  dataSource={storagePlacesApi.get}
                  value={entity.storagePlace}
                  onChange={updateEntity('storagePlace')}
                  nullable
                  />
              </Validator>
            </AddItemButton>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <Label>{localize('bottles.storageLocation')}</Label>
            <Validator name='storageLocation' value={entity.storageLocation} min={0} max={2147483647}>
              <Input isNumeric disabled={disabled} value={entity.storageLocation} onChange={updateEntity('storageLocation')} />
            </Validator>
          </Col>
        </Row>
        <Row><Col><hr /></Col></Row>
        <Row>
          <Col sm={3}>
            <Label>{localize('bottles.actualPrice')}</Label>
            <Validator name='actualPrice' value={entity.actualPrice} required>
              <Input isNumeric disabled={disabled} value={entity.actualPrice} onChange={updateEntity('actualPrice')} />
            </Validator>
          </Col>
          <Col sm={3}>
            <Label>{localize('bottles.dateOfSale')}</Label>
            <Validator name='dateOfSale' value={entity.dateOfSale} disabled={disabled} style={{ width: 205 }} required={entity.status === storageStatus.sold}>
              <DatePicker disabled={disabled} value={entity.dateOfSale} onChange={updateEntity('dateOfSale')} />
            </Validator>
          </Col>
          <Col sm={3}>
            <Label>{localize('bottles.soldByChannel')}</Label>
            <Validator name='soldByChannel' value={entity.soldByChannel} required={entity.status === storageStatus.sold}>
              <Select value={entity.soldByChannel} onChange={updateEntity('soldByChannel')}
                placeholder={localize('bottles.soldByChannel')} disabled={disabled} nullable
                enum={soldByChannel} />
            </Validator>
          </Col>
          
        </Row>
        <Row><Col><hr /></Col></Row>
        <Row className={isInDialog ? '' : classes.footer}>
          <Col sm={12}>
            <QuickSellButtons 
              quickSelling={quickSelling}
              quickSell={quickSell}
              localize={localize}
              isInDialog={isInDialog}
              context={context}
              data={data} />
          </Col>
        </Row>

      </RsForm>
    </React.Fragment>

  )
}

export default React.memo(Form)